const list = [
  {
    id: 1,
    title: '商务BD经理',
    type: '商务',
    experience: '五年以上工作经验',
    welfare:'10k-20k+绩效+项目利润+五险一金+年终奖+员工福利+带薪年假',
    address: '全国',
    date: '2025-03-06',
    work:['根据公司战略和市场动态，制定并执行校园业务的商务拓展计划，负责拓展职教类院校的校园网及智慧校园业务。',
    '负责为公司引进并接入各地市运营商渠道资源，尤其与教育行业相关，确保校园WiFi快速落地并全面铺开。',
    '负责校园网及智慧校园等合作项目的落地实施和全流程管理。',
    '负责校园网及智慧校园建设过程中整体成本控制以及获取用户的成本的有效管理。',
    '负责客情关系的维护以及客户对项目期望值的管理，协调资源，并及时解决项目执行过程中出现的各类问题。'],
    requirement: ['本科及以上学历，5年及以上年商务拓展或销售经验，有成功案例者最佳，有做过校园网项目的优先。',
      '熟悉运营商业务及校园市场，有运营商省市公司、区分公司或教育行业相关等渠道资源。',
      '具有校园相关项目资源者优先。' +
    '对校园网及智慧校园业务方案有一定的了解，具备解决方案的沟通能力。',
      '良好的客户沟通、资源协调能力；良好的分析问题及解决问题能力；能接受出差。']
  },
  {
    id: 2,
    title: 'Java开发工程师',
    type: '开发',
    welfare:'10-15k+五险一金+年终奖+员工福利+带薪年假',
    experience: '三年以上工作经验',
    address: '深圳',
    date: '2025-03-06',
    work:['负责公司产品研发工作。',
      '参与系统的需求分析、设计、编码等开发工作。',
      '配合项目组长完成相关的工作计划制定并达成工作目标。'],
    requirement: ['计算机相关专业，统招本科及以上学历，3年工作经验及以上。',
      '具备扎实的Java语言基础、熟悉J2EE架构体系。',
      '熟悉主流Java开源框架，如：Spring、MyBatis、Maven、Redis、Netty等。',
      '熟悉MySQL数据库，有良好的数据库设计能力和SQL编写能力',
      '了解或具备网络管理系统及设备类的开发经验者优先考虑。',
      '责任心强，有较好的表达沟通能力，工作认真负责，善于学习。']
  },

  {
    id: 3,
    title: '售前技术支持',
    type: '售前',
    welfare:'12-20k+五险一金+年终奖+员工福利+带薪年假',
    experience: '三年以上工作经验',
    address: '深圳',
    date: '2025-03-06',
    work:['客户需求分析与方案设计：调研高职及本科院校网络、信息化建设需求，提供定制化智慧校园及无线网络解决方案，针对校园一脸通、宿舍网络、校园安防等场景设计技术架构，输出方案书、拓扑图及预算清单。',
      '技术支撑与商务协作：配合商务团队完成客户拜访、技术交流等工作，主导技术应答与方案讲解，编写标书技术部分、可行性报告及验收文档，确保方案与客户需求、招标要求高度匹配。',
      '行业洞察与竞品分析：跟踪教育行业政策（如职教信息化、智慧校园建设指南），分析院校数字化转型趋势，提炼产品优势，研究竞争对手解决方案，优化技术策略并赋能商务团队制定竞争策略。',
      '跨部门协同与培训：联动产品、研发部门传递客户需求，推动产品迭代，为交付团队交底，确保项目落地，定期为商务、项目团队及合作伙伴开展技术培训，提升团队方案宣讲与客户答疑能力。'],
    requirement:['硬性条件 ：本科及以上学历，计算机、通信、网络工程等相关专业，3年以上售前/技术支持经验（教育行业背景优先）。',
      '熟悉无线网络技术（AC/AP组网、射频规划）、基础网络安全架构，具备H3CSE/CCNP/HCIP等认证及以上者优先。',
      '.熟练使用Visio、CAD绘制技术方案，精通PPT编写与演讲，能快速响应标书技术章节撰写。',
      '软性能力：具备优秀客户沟通能力，能理解院校不同部门需求，逻辑清晰、抗压性强，适应短期出差，有高校信息化项目成功案例优先。',
      '熟悉智慧教室、校园一卡通、AIoT等子系统集成方案，或具有华为/锐捷等厂商生态合作经验优先。',
      '对职教改革政策、本科院校数字化评级标准（如《高校智慧校园建设指南》）有深入研究优先。']
  },

  {
    id: 4,
    title: '运维主管/经理',
    type: '运维',
    welfare:'15-25k+五险一金+年终奖+员工福利+带薪年假',
    experience: '五年以上工作经验',
    address: '深圳',
    date: '2025-03-06',
    work:['监控和评估办事处网络系统的稳定性和性能，确保业务连续性。',
      '快速响应网络故障，指导和协调团队进行故障排除。',
      '制定和实施网络故障预防和应急响应计划。',
      '管理和优化用户投诉处理流程，确保用户问题能够得到及时和有效的解决。',
      '分析用户投诉数据，识别服务中的薄弱环节，提出改进措施。',
      '定期与用户沟通，了解服务表现和用户满意度。',
      '为办事处运维人员提供必要的技术支持和培训，提升团队的故障处理能力。',
      '更新和维护技术支持文档，确保团队成员能够快速获取必要的信息。',
      '监控服务质量，确保服务水平符合公司标准。',
      '定期审查服务质量指标，如故障响应时间和解决时间。'],
    requirement: ['计算机科学、信息技术或相关领域的本科及以上学历。',
      '至少3年以上的IT运维管理经验，有网络故障管理和用户投诉处理经验者优先。',
      '精通网络架构、故障排除工具和方法，熟悉主流的网络监控和管理系统。',
    '具有较强的战略规划能力、项目管理能力、逻辑分析判断能力。',
    '有服务台管理系统的设计或使用经验，精通ITIL流程中的ITSM事件管理流程，擅长解决IT服务中的疑难问题。',
      '具备领导和激励团队的能力，能够提升团队士气和工作效率。'
      ,'能够迅速识别问题并提出有效的解决方案。'],
  },
  {
    id: 5,
    title: '视觉设计师（UI/品牌方向）',
    type: '设计',
    welfare:'10-15k+五险一金+年终奖+员工福利+带薪年假',
    experience: '三年以上工作经验',
    address: '深圳',
    date: '2025-03-06',
    work:['UI 设计方向：负责公司 Web/App/H5 等产品界面视觉设计，输出高保真原型、设计规范及切图资源，结合反馈和数据分析迭代界面设计，配合产品经理、开发团队完成设计落地，配合电商团队团队制作产品主图、商品详情页等。',
      '品牌视觉设计方向：主导品牌 VI 系统（Logo、字体、色彩、视觉延展等）设计与迭代，独立完成线上线下营销物料（包括海报、宣传册、活动主KV、展架、包装、周边礼品等）及社交媒体视觉内容设计（公众号配图）等，参与品牌创意策划并提供设计支持。',
      'AI 工具应用：熟练运用 AI 工具辅助创意生成、素材优化和排版设计，提升设计效率。任职要求'],
    requirement: ['本科及以上学历，视觉传达设计、数字媒体艺术、平面设计等相关专业。',
      '三年以上 UI 及品牌视觉设计经验，需要提供作品集。',
      '技能要求：精通视觉AI工具，包括但不限于MidJourney 等创意生成、Adobe Firefly 等设计辅助、Remove.bg 等效率工具类视觉 AI 软件。',
      '加分项：有互联网、TO B 行业设计经验，熟悉营销策略并能讲品牌语言转化为视觉符号。',
      '其他要求：注重细节，具备强审美与创新意识，沟通高效，能适应快节奏项目，抗压且对设计负责。'],
  },
  {
    id: 6,
    title: 'HRM人力资源经理',
    type: 'HR',
    welfare:'15-25k+五险一金+年终奖+员工福利+带薪年假',
    experience: '五年以上工作经验',
    address: '深圳',
    date: '2025-03-06',
    work:['全面统筹公司人力资源行政工作，建立并持续完善、升级人力资源管理基础体系。',
      '公司成功=战略*组织能力，参与公司发展战略规划，并相应制订人力资源战略和组织能力发展规划。',
      '在招聘、培训、绩效激励、薪酬、企业文化、员工关系等各方面分阶段、有重点、有计划的制订方案并组织实施。'],
    requirement: ['本科以上学历，5年以上中型企业HR工作经验。',
      'IT/互联网/通讯行业从业经验者优先。',
      '有经历企业创业阶段、快速发展阶段到初步成熟阶段者优先。',
      '有对阿米巴组织模式、OKR有了解和经验者者优先。',
      '具有优秀的学习能力、沟通表达能力和组织能力'],
  },
  {
    id: 7,
    title: 'AI产品经理',
    type: '产品',
    welfare:'15k-30k+五险一金+年终奖+员工福利+带薪年假',
    experience: '三年以上工作经验',
    address: '深圳',
    date: '2025-03-06',
    work:['参与规划和建设公司 AI 能力，挖掘用户场景、输出产品设计方案。',
      '探索 AI 技术在公司现有业务中的应用潜力，规划产品发展方向。',
      '进行市场和技术研究，掌握行业趋势并利用新兴 AI 技术。',
      '定义并管理 AI 需求池、交付和里程碑，确保 AI 相关功能的及时落地'],
    requirement: ['第一学历本科及以上，计算机、人工智能等相关专业。',
      'AI工具应用：熟练掌握各种AI工具的使用技巧，熟悉AGENT等运作机制，具备通过AI工具解决具体问题的丰富经验。熟悉主流平台/产品，如KIMI/豆包/Coze/Perplexity/Dify，至少独立搭建过一款智能体并实际使用。',
      '清晰理解AI能力的边界，并能快速提炼工作流，对需求进行评估，判断WHY（为何要做/不做）和设计HOW with AI（怎么做）。',
      '对 AI 领域持续关注和思考，好奇心强，对新事物敏感。'],
  },

]

export default list



// WEBPACK FOOTER //
// ./src/pages/about/recruitment.js